import { stubbedFollowFriends } from '../stubbedData';

export const POPULATE_FOLLOWER_REQUESTS = 'POPULATE_FOLLOWER_REQUESTS';
export const REMOVE_DISMISSED_FOLLOWER_REQUEST = 'REMOVE_DISMISSED_FOLLOWER_REQUEST';

export const populateFollowerRequests = () => {
  // TODO: Add in request to belay service https://alltrails.atlassian.net/browse/SVR-4937
  return {
    type: POPULATE_FOLLOWER_REQUESTS,
    payload: stubbedFollowFriends
  };
};

export const dismissFollowRequest = (userId, href) => {
  // TODO: Add in request for belay and then after request https://alltrails.atlassian.net/browse/SVR-4937

  return {
    type: REMOVE_DISMISSED_FOLLOWER_REQUEST,
    payload: userId
  };
};

export const initialFollowerRequestsState = {
  followerRequests: []
};

export default function followerRequests(state = initialFollowerRequestsState, action) {
  switch (action.type) {
    case POPULATE_FOLLOWER_REQUESTS:
      return {
        ...state,
        followerRequests: action.payload
      };
    case REMOVE_DISMISSED_FOLLOWER_REQUEST:
      return {
        ...state,
        followerRequests: [
          ...state.followerRequests.filter(followerRequest => {
            return followerRequest.user.id !== action.payload;
          })
        ]
      };
    default:
      return state;
  }
}
